import sc from 'styled-components';
import _ from 'lodash';
import React from 'react';
import {
  MAIN_PAGE_MARGIN_HEIGHT,
  MAIN_PAGE_MARGIN_WIDTH,
  MAIN_PAGE_MARGIN_HEIGHT_SM,
  MAIN_PAGE_MARGIN_WIDTH_SM,
  MAIN_PAGE_MARGIN_TOP,
  MAIN_PAGE_MARGIN_TOP_SM,
  MEDIA_MD,
} from './styleConstants';

/**
 * This is the outermost Padding for any root component/page. You must put it in any
 * root page to allow for other elements (drawers etc.) to be outside it.
 */
const PageFrame = sc.div`
  padding: ${MAIN_PAGE_MARGIN_HEIGHT} ${MAIN_PAGE_MARGIN_WIDTH};
  padding-top: ${MAIN_PAGE_MARGIN_TOP};
  ${({ noTop }) => noTop && 'padding-top: 0;'}
  ${({ noBottom }) => noBottom && 'padding-bottom: 0;'}
  @media screen and (max-width: ${MEDIA_MD}) {
    padding: ${MAIN_PAGE_MARGIN_HEIGHT_SM} ${MAIN_PAGE_MARGIN_WIDTH_SM};
    padding-top: ${MAIN_PAGE_MARGIN_TOP_SM};
    ${({ noTop }) => noTop && 'padding-top: 0;'}
    ${({ noBottom }) => noBottom && 'padding-bottom: 0;'}
  }
`;

export default props => (
  <PageFrame data-type="page frame" {...props} className={`page frame ${_.get(props, 'className', '')}`}>
    {props.children}
  </PageFrame>
);
